// @mui
import {
  Dialog,
  DialogTitle,
  DialogActions,
  Typography,
  Button,
  IconButton,
  DialogContent,
  useTheme,
  Box,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useEffect } from 'react';
import { useDispatch, useSelector } from '../redux/store';
import { resetConfirmState, setLoading, setOpen } from '../redux/slices/confirm';
import Iconify from './Iconify';
import useLocales from '../hooks/useLocales';
import MyDialog from './dialog-component/my-dialog';
// import { resetConfirmState } from '../redux/slices/confirm';

// ----------------------------------------------------------------------

export default function CustomConfirm() {
  const theme = useTheme();

  const { isLoading, open, title, subTitle, onConfirm, onCancel, isInfo, isDanger } = useSelector(
    (state) => state.confirm
  );

  const { translate } = useLocales();

  const dispatch = useDispatch();

  useEffect(() => () => dispatch(resetConfirmState()), []);

  const handleCancel = () => {
    if (onCancel && typeof onCancel === 'function') {
      onCancel();
    }
    dispatch(setOpen(false));
    setTimeout(() => dispatch(resetConfirmState()), 500);
  };

  const handleConfirm = async () => {
    if (onConfirm && typeof onConfirm === 'function') {
      dispatch(setLoading(true));
      await onConfirm();
      dispatch(setLoading(false));
    }

    dispatch(setOpen(false));
    setTimeout(() => dispatch(resetConfirmState()), 500);
  };

  return (
    <MyDialog open={open} close={handleCancel} maxSize={'sm'} hasDialogContent={false}>
      <DialogTitle>
        <Typography fontWeight={'bold'}>{title}</Typography>
      </DialogTitle>
      <DialogContent>
        <Typography component={'div'} variant="body2">
          {subTitle}
        </Typography>
      </DialogContent>
      <Box
        sx={{
          display: 'flex',
          alignContent: 'end',
          justifyContent: 'end',
          gap: 2,
          paddingBottom: 2,
          paddingX: 2,
        }}
      >
        {!isInfo && (
          <Button variant="outlined" color="inherit" onClick={handleCancel}>
            {translate('No')}
          </Button>
        )}

        <LoadingButton
          type="submit"
          variant="contained"
          color={isDanger ? 'error' : 'primary'}
          loading={isLoading}
          disabled={isLoading}
          onClick={handleConfirm}
        >
          {translate(isInfo ? 'Ok' : 'Yes')}
        </LoadingButton>
      </Box>
    </MyDialog>
  );
}
